import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

export function useLiveStatusData(
  deviceId: string | undefined,
  minutesBack: number = 5,
  refetchInterval: number = 10000,
) {
  const { geotabClient, activeSessionId } = useGeotabClient();
  return useQuery({
    queryKey: ["liveStatusData", activeSessionId, deviceId, minutesBack],
    queryFn: async ({ signal }) => {
      const fromDate = new Date(Date.now() - minutesBack * 60 * 1000);
      return geotabClient.get(
        "StatusData",
        {
          deviceSearch: { id: deviceId },
          fromDate,
        },
        50000,
        signal,
      );
    },
    enabled: !!deviceId,
    refetchInterval,
    placeholderData: keepPreviousData,
  });
}
